import { EntryType } from '__types__/entities';
import { Archivable, Ownable } from './baseTypes';

export enum MetastructureFieldType {
  Core = 'CORE_FIELD',
  Custom = 'CUSTOM_FIELD',
  CustomGroup = 'CUSTOM_FIELD_GROUP'
}

type BaseMetastructureField = {
  active: boolean;
  locked: boolean;
  default: string;
  required: boolean;
};

type MetastructureFieldCore = BaseMetastructureField & {
  type: MetastructureFieldType.Core;
  name: string;
};

type MetastructureFieldCustom = BaseMetastructureField & {
  type: MetastructureFieldType.Custom;
  custom_field_definition_id: EntityId;
};

type MetastructureFieldCustomGroup = BaseMetastructureField & {
  type: MetastructureFieldType.CustomGroup;
  custom_fieldgroup_definition_id: EntityId;
};

export type MetastructureField =
  | MetastructureFieldCore
  | MetastructureFieldCustom
  | MetastructureFieldCustomGroup;

export type Metastructure = Archivable &
  Ownable & {
    entity_type?: EntryType;
    fields: MetastructureField[];
    field_order?: string[];
  };
